// POST Question types
export const LOGIN_REQUEST = "POST_AUTH_REQUEST";
export const LOGIN_SUCCESS = "POST_AUTH_SUCCESS";
export const LOGIN_FAILURE = "POST_AUTH_FAILURE";

export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST";
